// frontend/src/components/chatbot/EmailPopup.tsx
import React, { useEffect, useRef, useState } from 'react';
import { Mail } from 'lucide-react';

interface EmailPopupProps {
  email: string;
  subject?: string;
}

const EmailPopup: React.FC<EmailPopupProps> = ({ email, subject = 'Pista app support' }) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (!isOpen) return;
    const handleClick = (event: MouseEvent) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [isOpen]);

  const mailto = `mailto:${email}?subject=${encodeURIComponent(subject)}`;

  return (
    <span className="chatbot-email-wrapper" ref={wrapperRef}>
      <button
        type="button"
        className="chatbot-email-button"
        onClick={() => setIsOpen((prev) => !prev)}
        aria-label={`Email ${email}`}
      >
        <Mail size={12} />
        {email}
      </button>
      {isOpen && (
        <span className="chatbot-email-popup" role="dialog" aria-label="Email options">
          <span className="chatbot-email-popup-address">{email}</span>
          <a
            href={mailto}
            className="chatbot-email-popup-link"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => setIsOpen(false)}
          >
            <Mail size={14} />
            Send email
          </a>
        </span>
      )}
    </span>
  );
};

export default EmailPopup;
